import {
  IAutoCompleteItem,
  IAutoCompleteValue,
} from '../../../models/autoComplete';
import { IPricingPlan, SubscriptionModel } from '../../../models/pricingPlan';

export const findPricingPlanBySubscriptionModel = (
  pricingPlans: IPricingPlan[],
  subscriptionModel: SubscriptionModel
): IAutoCompleteValue | undefined => {
  const id = pricingPlans?.find(
    (pricingPlan) => pricingPlan?.subscriptionModel === subscriptionModel
  )?.id;
  return id ? Number(id) : undefined;
};

export const mapPricingPlansBySubscriptionModel = (
  pricingPlans: IPricingPlan[],
  subscriptionModel: SubscriptionModel
): IAutoCompleteItem[] => {
  return pricingPlans
    .filter(
      (pricingPlan: IPricingPlan) =>
        pricingPlan.subscriptionModel === subscriptionModel
    )
    .map((pricingPlan: IPricingPlan) => ({
      id: Number(pricingPlan.id),
      label: pricingPlan.title,
    }));
};
